//Internal import
import { Dictionary } from "@/types/theme";

//External import
import i18n from "i18next"
import { initReactI18next } from "react-i18next"
/**
 * i18n configs are placed here
 */
i18n.use(initReactI18next).init({
  lng: "fa",
  ns: ["common", "routes", "validation"],
  defaultNS: "common",
  resources: {
    fa: {
      common: {},
      routes: {},
      validation: {},
    },
  },
})

export const updateTranslations = (translations: Dictionary) => {
  if (!translations) return;

  i18n.addResources("fa", "common", translations.common || {});
  i18n.addResources("fa", "routes", translations.routes || {});
  i18n.addResources("fa", "validation", translations.validation || {});

  i18n.changeLanguage("fa");
};

export default i18n

